
import { defineComponent, reactive, ref } from "vue";
import { Field, Form } from "vee-validate";
import Switch from "@/components/widgets/custom/Switch.vue";
import moment from "moment";
import ApiService from "@/core/services/ApiService";
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from "vue-router";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
const programmers = [
  "BE AJI",
  "BE ZUL",
  "BE ILHAM",
  "BE YAZID",
  "FE NUR",
  "FE INDRA",
  "FE TEGUH",
  "MOBILE AAN",
];

interface FeatureData {
  name: string;
  releaseDate: string;
  description: string;
  programmer: string;
  position: string;
  status: string;
  is_default: boolean;
}

interface ModuleDetail {
  moduleKey: string;
  moduleDescription: string;
  status: string;
  is_default: boolean;
}

export default defineComponent({
  name: "Add Feature",
  components: {
    Field,
    Form,
    Switch,
    loading,
  },
  setup() {
    const isLoading = ref(false);
    const fullPage = ref(true);
    const isColor = "#007BFF";
    const isBackgroundColor = "#A3A3A3";
    const isOpacity = 0.5;
    const userStorage = ref(localStorage.getItem("user_account"));
    const currentUser = ref();
    const toast = useToast();
    const router = useRouter();
    const route = useRoute();

    if (userStorage.value) {
      currentUser.value = JSON.parse(userStorage.value);
    }

    const featureData = reactive<FeatureData>({
      name: "",
      releaseDate: "",
      description: "",
      programmer: "",
      position: "",
      status: "",
      is_default: false,
    });

    const moduleDetail = ref<ModuleDetail[]>([
      {
        moduleKey: "",
        moduleDescription: "",
        status: "Inactive",
        is_default: false,
      },
    ]);

    const addModuleDetail = (index) => {
      console.log(index);

      if (
        moduleDetail.value[index].moduleDescription === "" ||
        moduleDetail.value[index].moduleKey === ""
      )
        return toast.warning("field tidak boleh kosong");
      moduleDetail.value.push({
        moduleKey: "",
        moduleDescription: "",
        status: "Inactive",
        is_default: false,
      });
    };

    const changeStatus = (index: number) => {
      moduleDetail[index].status =
        moduleDetail[index].status === "Active" ? "Inactive" : "Active";
    };

    const removeDetail = (index) => {
      moduleDetail.value.splice(index, 1);
    };

    const handleSubmit = () => {
      isLoading.value = true;
      const savedDetailModules = moduleDetail.value.map((item) => {
        return {
          module_key: item.moduleKey,
          module_description: item.moduleDescription,
          status: item.status,
          is_default: item.is_default,
        };
      });
      const data = {
        createTime: moment().toISOString(),
        creatorId: currentUser.value.userId,
        updateTime: moment().toISOString(),
        editorId: currentUser.value.userId,
        isDelete: false,
        deleteBy: null,
        deleteTime: moment().toISOString(),
        feature_name: featureData.name,
        release_date: featureData.releaseDate,
        description: featureData.description,
        programmer: featureData.programmer,
        feature_location: featureData.position,
        feature_status: featureData.status,
        detail_modules: savedDetailModules,
        is_default: featureData.is_default,
      };
      ApiService.putWithData(
        `crmv2/main_feature/feature-master/${route.params._id}`,
        data
      )
        .then((res) => {
          toast.success("Data berhasil disimpan");
          router.push("/superadmin/master-feature/data");
        })
        .catch((e) => {
          console.log(e);

          if (e.response.status == 401) {
            toast.error(e.response.data.detail);
            router.push("/sign-in");
            isLoading.value = false;
          } else {
            toast.error("Something went wrong");
            isLoading.value = false;
          }
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const getData = () => {
      isLoading.value = true;
      const id = route.params._id;
      ApiService.getWithoutSlug("crmv2/main_feature/feature-master/" + id)
        .then((res) => {
          console.log(res.data.data);

          featureData.name = res.data.data.feature_name;
          featureData.releaseDate = res.data.data.release_date;
          featureData.description = res.data.data.description;
          featureData.position = res.data.data.feature_location;
          featureData.status = res.data.data.feature_status;
          featureData.programmer = res.data.data.programmer;
          featureData.is_default = res.data.data.is_default;

          moduleDetail.value = res.data.data.detail_modules.map((item) => {
            return {
              moduleKey: item.module_key,
              moduleDescription: item.module_description,
              status: item.status,
              is_default: item.is_default,
            };
          });
          isLoading.value = false;
        })
        .catch((e) => {
          console.log(e);
          toast.error("error fetching data");
          isLoading.value = false;
        });
    };

    return {
      isLoading,
      fullPage,
      isColor,
      isBackgroundColor,
      isOpacity,
      featureData,
      moduleDetail,
      programmers,
      addModuleDetail,
      changeStatus,
      removeDetail,
      handleSubmit,
      getData,
    };
  },
  mounted() {
    this.getData();
  },
});
